import React from "react";
// threejs
import { Canvas } from "@react-three/fiber";

const ThreeScene = ({ children }) => {
    return <Canvas camera={{ position: [180, 100, 140] }}>{children}</Canvas>;
};

export default ThreeScene;
